<template>
    <v-toolbar dense color="accent" class="elevation-4" style="margin: 15px 15px 10px;">
        <v-toolbar-title>
            <!--img style="height: 56px; margin-top: 9px;" src="../../assets/simomics.svg"-->
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <selectorPC :filter="filters.substances" label="Substances" @click="dialogSubstances = true"></selectorPC>
        <selectorDialog v-model="dialogSubstances" :filter="filters.substances" :sortItemsCaseInsensitive="true" label="Substances">
        </selectorDialog>

        <selectorPC :filter="filters.goals" label="Protection Goals" :multiple="false" @click="dialogGoals = true">
        </selectorPC>

        <!--selectorDialog v-model="dialogGoals" :filter="filters.goals" :multiple="false" label="Protection Goals">
        </selectorDialog-->

        <selectorDialog v-model="dialogGoals" :filter="filters.goals" :multiple="false" label="Protection Goals">
            <template v-slot:message>
                <v-card-text>
                    The PNECs displayed in the tool are based on risk to aquatic organisms only,
                    however this will be expanded to include other protection goals in future.
                </v-card-text>
            </template>
        </selectorDialog>

        <selectorPC :filter="filters.compartments" label="Compartments" @click="dialogCompartments = true"></selectorPC>
        <selectorDialog v-model="dialogCompartments" :filter="filters.compartments" label="Environmental Compartments">
        </selectorDialog>

        <selectorPC :filter="filters.locations" label="Regions" @click="dialogLocations = true"></selectorPC>
        <selectorDialog v-model="dialogLocations" :filter="filters.locations" label="Regions">
        </selectorDialog>

        <selectorPC :filter="filters.detects" :label="filters.detects.isShow() ? 'RQ All Data' : 'RQ Detects Only'"
            :multiple="false" onlyLabel @click="filters.detects.toggle">
        </selectorPC>

        <v-btn text class="px-2" color="white" style="text-transform: none !important; font-size: 13px; letter-spacing: normal !important;" @click="reset()">
              <span style="color:#000000DE">Reset All
            <v-icon class="ml-1" style="margin-bottom: 2px" small>
                mdi-refresh
            </v-icon></span>
        </v-btn>

        <v-btn text color="white" @click="dialogHelp = true" style="text-transform: capitalize; font-size: 13px;">
            <!-- FIXME: hardcoded breakpoint -->
            <template v-if="this.$vuetify.breakpoint.width > 1040">
                 <span class="font-weight-bold">Information</span>
            </template>
            <v-icon class="ml-1">
                mdi-information
            </v-icon>
        </v-btn>

        <helpDialog v-model="dialogHelp">
        </helpDialog>
    </v-toolbar>
</template>

<script>
    import { Filters } from '../../ts/filters'
    import selectorPC from './selectorPC.vue'
    import selectorDialog from './dialogs/selectorDialog.vue'
    import helpDialog from './dialogs/helpDialog.vue'

    export default {
        components: {
            selectorPC,
            selectorDialog,
            helpDialog,
        },
        props: {
            filters: {
                required: true,
                type: Filters
            }
        },
        data() {
            return {
                dialogSubstances: false,
                dialogGoals: false,
                dialogCompartments: false,
                dialogLocations: false,

                dialogHelp: false,
            }
        },
        methods: {
            reset() {
                this.filters.selectAll()
                this.$emit('resetAll')
            }
        }
    }
</script>

<style scoped>
    .navbuttons {
        text-transform: capitalize;
        font-weight: normal;
        font-size: 13px;
    }
    /* Remove highlight after click: https://github.com/vuetifyjs/vuetify/issues/3125 */
    .btn-fix:focus::before { opacity: 0 !important; }
</style>
